module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/affiliate/global/member/images/NiftyStats.png", __webpack_public_path__ + "_/_/global/member/images/NiftyStats.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/affiliate/global/member/images/NiftyStats.png
// module id = 78
// module chunks = 5